import { ColumnDef } from '@tanstack/react-table'
import { ProviderSummary } from '../../types'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { Eye } from 'lucide-react'

export const columns: ColumnDef<ProviderSummary>[] = [
	{
		accessorKey: 'providerName',
		header: 'ผู้ให้บริการ',
		cell: ({ row }) => {
			const name = row.getValue('providerName') as string
			return <div className="font-medium">{name}</div>
		},
	},
	{
		accessorKey: 'totalSuccessTransaction',
		header: 'จำนวนธุรกรรม',
		cell: ({ row }) => {
			const value = row.getValue('totalSuccessTransaction') as number
			return <div className="">{value.toLocaleString()}</div>
		},
	},
	{
		accessorKey: 'totalTurnOver',
		header: 'ยอดเทิร์น',
		cell: ({ row }) => {
			const value = row.getValue('totalTurnOver') as number
			return <div className="">{value.toLocaleString()}</div>
		},
	},
	{
		accessorKey: 'totalTransferIn',
		header: 'ยอดโอนเข้า',
		cell: ({ row }) => {
			const value = row.getValue('totalTransferIn') as number
			return <div className="text-green-600">{value.toLocaleString()}</div>
		},
	},
	{
		accessorKey: 'totalTransferOut',
		header: 'ยอดโอนออก',
		cell: ({ row }) => {
			const value = row.getValue('totalTransferOut') as number
			return <div className="text-red-600">{value.toLocaleString()}</div>
		},
	},
	{
		accessorKey: '',
		header: 'กินลูกค้า',
		cell: ({ row }) => {
			const transferIn = row.getValue('totalTransferIn') as number
			const transferOut = row.getValue('totalTransferOut') as number
			const profit = transferIn - transferOut
			const color = profit >= 0 ? 'text-green-600' : 'text-red-600'
			return <div className={` ${color}`}>{profit.toLocaleString()}</div>
		},
	},
	{
		accessorKey: 'totalBetAmount',
		header: 'ยอดเดิมพัน',
		cell: ({ row }) => {
			const value = row.getValue('totalBetAmount') as number
			return <div className="">{value.toLocaleString()}</div>
		},
	},
	{
		accessorKey: 'totalSettleAmount',
		header: 'ยอดจ่าย',
		cell: ({ row }) => {
			const value = row.getValue('totalSettleAmount') as number
			return <div className="">{value.toLocaleString()}</div>
		},
	},
	// {
	// 	accessorKey: 'totalCompany',
	// 	header: 'ยอดบริษัท',
	// 	cell: ({ row }) => {
	// 		const value = row.getValue('totalCompany') as number
	// 		const rate = row.original.companyRate
	// 		return (
	// 			<div className="">
	// 				<div className="font-medium text-blue-600">
	// 					{value.toLocaleString()}
	// 				</div>
	// 				<div className="text-xs text-muted-foreground">({rate}%)</div>
	// 			</div>
	// 		)
	// 	},
	// },
	{
		id: 'actions',
		header: 'รายละเอียด',
		cell: ({ row }) => {
			const providerName = row.original.providerName
			return (
				<Link to={`/operator/play-logs?providerName=${providerName}`}>
					<Button
						variant="outline"
						size="sm"
						className="flex items-center gap-2"
					>
						<Eye className="h-4 w-4" />
						ดูรายละเอียด
					</Button>
				</Link>
			)
		},
	},
]
